import React from 'react';
import schoolPhoto from '../assets/images/about-school-photo.jpg';
import useReveal, { reveal } from '../hooks/useReveal';

/*
  The mission statement, carried over from the previous About section. The one
  change to the copy is the removal of an unverifiable claim ("reduce
  administrative overhead by up to 60%"); the qualitative points are unchanged.

  This is the only centred section on the page. The message is the design here,
  so the composition stays deliberately quiet.
*/
const About = () => {
  const [ref, isVisible] = useReveal();

  return (
    <section id="about" className="ab-section ab-about" ref={ref}>
      <div className="ab-shell ab-about__inner">
        <div className={`ab-about__copy ${reveal(isVisible)}`}>
          <h2 className="ab-h2">Built for the people who run schools</h2>
          <p className="ab-lead">
            Running a school means holding a hundred things at once: student progress, the register,
            fees, staff, and every parent who needs an answer today. AtadaBoard was built to put
            those in one secure place your team can reach from anywhere.
          </p>
        </div>

        <figure className={`ab-about__figure ${reveal(isVisible)}`} style={{ '--ab-reveal-delay': '90ms' }}>
          <img
            src={schoolPhoto}
            alt="A student working on a laptop in a classroom"
            width="640"
            height="447"
            loading="lazy"
            decoding="async"
          />
        </figure>
      </div>

      <style jsx>{`
        .ab-about__inner {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
        }

        .ab-about__copy { max-width: 40rem; }

        .ab-about__copy .ab-lead {
          margin: 1rem auto 0;
          font-size: clamp(1.0625rem, 1.4vw, 1.25rem);
        }

        .ab-about__figure {
          margin: clamp(2.5rem, 4vw, 3.5rem) 0 0;
          width: 100%;
          max-width: 560px;
        }

        .ab-about__figure img {
          display: block;
          width: 100%;
          height: auto;
          border-radius: var(--ab-r-card);
          box-shadow: var(--ab-shadow-md);
        }
      `}</style>
    </section>
  );
};

export default About;
